<template lang="pug">
  v-menu(v-if="isTokenSet" bottom origin="center center" transition="scale-transition" offset-y allow-overflow max-height="600")
    template(v-slot:activator="{ on }")
      v-btn(color="#2C3A47" class="white--text" v-on="on" class="mr-2" class="hidden-xs-only") {{ selectedHotspot }}
      v-btn(color="#2C3A47" class="white--text" v-on="on" class="mr-2 d-flex d-sm-none")
        v-icon mdi-account-network

    v-list
      v-list-item(@click="" v-for="(item, i) in hotspots" :key="i")
        v-list-item-title(@click="changeHotspot(i)") {{ item }}
        //v-list-item-title(@click="changeHotspot(item)") {{ item }}
          //router-link(to="#")
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  name: 'HotspotChanger',
  data: () => ({
    selectedHotspot: '',
    hotspots: []
  }),

  methods: {
    ...mapActions(['getHotspots']),
    changeHotspot(hotspot) {
      this.$store.dispatch('setHotspot', hotspot)
      this.selectedHotspot = hotspot
    }
  },

  computed:{
    ...mapGetters(['isTokenSet', 'user']),
    // hotspots() {
    //   //if(this.isTokenSet){ return this.user.hotspots }
    //   if(this.isTokenSet){
    //     let user = localStorage.getItem('user')
    //     user = user ? JSON.parse(user) : {}
    //     console.log('returning hotspots: '+user['hotspots'])
    //     return user.hotspots
    //   }
    // }
  },

  async created() {
    if(window.localStorage.getItem('selectedHotspot') != null){
      this.selectedHotspot = window.localStorage.getItem('selectedHotspot').split('"').join('')
    }
    // if(this.isTokenSet && this.user.hotspots[0] == 'all'){ // SUPER-ADMIN - pega todos os hotspots
    //   await this.getHotspots({ })
    //   let user = localStorage.getItem('user')
    //   user = user ? JSON.parse(user) : {}
    //   this.hotspots = user.hotspots
    // }else{ // USUARIO COMUM - pega apenas os hotspots que o usuário tem permissão
      console.log(JSON.stringify(this.user,null,2))
      if(this.user.hotspots){
        // método antigo
        //this.hotspots = this.user.hotspots.sort()

        // NOVO - hotspots ordenados
        const ordered = Object.keys(this.user.hotspotsAlias).sort().reduce(
          (obj, key) => {
            obj[key] = this.user.hotspotsAlias[key];
            return obj;
          },
          {}
        )

        console.log('ordered: '+JSON.stringify(ordered,null,2))

        this.hotspots = ordered


      }
    // }
  }
}
</script>
